import type { FunctionComponent } from 'react';

import { Price, Text, useClasses } from '@kanda-libs/ks-design-library';

import type { CheckoutFinanceRate } from 'pages/Quote/components/Rates/constants';

import { CLASS_NAMES } from './constants';
import useAPRLineItem from './useAPRLineItem';

export interface APRLineItemProps {
  name: string;
  value: string;
  rates: CheckoutFinanceRate[];
  isLoading: boolean;
}

const APRLineItem: FunctionComponent<APRLineItemProps> = function ({
  name,
  value,
  rates,
  isLoading,
}) {
  const { selected, onClick, maxCreditLine, maxDuration, isPreApproved } =
    useAPRLineItem(value, rates);

  const classNames = useClasses(CLASS_NAMES, {
    variants: {
      selected,
      preApproved: isPreApproved,
    },
  });

  return (
    <button
      type="button"
      className={classNames.wrapper}
      onClick={onClick}
      onKeyUp={onClick}
    >
      <div className={classNames.label}>{name} APR</div>
      <div className={classNames.extraItems}>
        <div className={classNames.extraItem}>
          <Text
            text={isPreApproved ? 'Pre Approved' : 'Max Borrow'}
            className={classNames.extraItemLabel}
            isLoading={isLoading}
          />
          <Price
            amount={maxCreditLine}
            className={classNames.extraItemValue}
            poundsClassName={classNames.extraItemValue}
            centsClassName={classNames.extraItemValue}
            isLoading={isLoading}
          />
        </div>
        <div className={classNames.extraItem}>
          <Text
            text="Max term"
            className={classNames.extraItemLabel}
            isLoading={isLoading}
          />
          <Text
            text={maxDuration}
            className={classNames.extraItemValue}
            isLoading={isLoading}
          />
        </div>
      </div>
    </button>
  );
};

export default APRLineItem;
